import React, { FC } from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';

import { isHome, isAccountPage } from 'config/routes';
import { IRootReducers } from 'src/reducers';
import { customFormatMessage, isConPlatform } from 'utils';
import CompleteProfilePrompt from 'src/components/account/profile/completeProfilePrompt';
import ProfilingBanner from 'src/components/layout/banner/ProfilingBanner';
import { isProfileCompleted } from 'utils/accountUtils';
import { UserBannerProfiling } from 'src/shared/enums';

const { PROFILE_ONLY, NOT_IN_PROFILE } = UserBannerProfiling;

type Props = ReturnType<typeof mapStateToProps>;

const HeaderBanner: FC<Props> = ({ user, userComesFromScan }): JSX.Element => {
  const { pathname } = useRouter();
  const isPublicHome: boolean = isHome(pathname) && !user;
  const isPrivateHome: boolean = isHome(pathname) && !!user;
  const isProfilePage: boolean = isAccountPage(pathname);
  const userIsSubscribed = user?.mcSegmentedSubscription === 1;
  const profilingBannerStatus = user?.temporalData?.profilingBannerStatus || 0;

  let content = null;
  switch (true) {
    case !isPublicHome && user?.blacklisted && userComesFromScan:
      content = (
        <div className="banner-wrapper">
          <div className="banner-blacklisted-error">
            {customFormatMessage('banner.blacklisted-error')}
            {customFormatMessage('banner.blacklisted-contact-us')}
          </div>
        </div>
      );
      break;
    case !isPublicHome && user?.blacklisted:
      content = (
        <div className="banner-wrapper">
          <div className="banner-blacklisted-warning">
            {customFormatMessage('banner.blacklisted-warning')}
            {customFormatMessage('banner.blacklisted-contact-us')}
          </div>
        </div>
      );
      break;
    case user &&
      !userIsSubscribed &&
      (!profilingBannerStatus ||
        (profilingBannerStatus === PROFILE_ONLY && isProfilePage) ||
        (profilingBannerStatus === NOT_IN_PROFILE && !isProfilePage)):
      content = <ProfilingBanner />;
      break;
    case isPrivateHome && !isProfileCompleted(user?.actionList):
      content = (
        <div className="banner-profilePoints">
          <CompleteProfilePrompt />
        </div>
      );
      break;
  }

  return isConPlatform && !!user && !!content ? content : null;
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    firstCompletedProfile: state.app.firstCompletedProfile,
    user: state.auth.user,
    userComesFromScan: state.app.fromScan,
  };
};

export default connect(mapStateToProps, null)(HeaderBanner);
